import React from 'react'
import './Kontak.css'
import { Helmet } from 'react-helmet';
import {
  Header,
  Banner,
  Good,
  Divider,
  Location,
} from "../../components/joinComponents";

const Kontak = () => {
  //  const header = {
  //    title: "Kontak",
  //    description: "Kampung Mundu",
  //    img: imgHeader,
  //  };
  return (
    <>
      <Helmet>
        <title>
          Kontak Kami: Kampung digital dan teknologi berbasis website.
        </title>
        <meta
          name='keyword'
          content='mundu, mundu 1902, moendoe, moendoe 1902, kampung digital, website desa, web keren, lubang buaya, jakarta timur, kampung keren'
        />
        <meta
          name='description'
          content='Mundu adalah sebuah nama daerah yang teletak di Jakarta Timur, Saat ini kami mengedepankan perubahan berbasis teknologi, untuk menjadikan kampung yang terdepan dalam setiap aspek kegiatan.'
        />
        <meta
          name='og:title'
          content='Gallery Kami: Kampung digital dan teknologi berbasis website.'
        />
        <meta
          name='og:description'
          content='Mundu adalah sebuah nama daerah yang teletak di Jakarta Timur, Saat ini kami mengedepankan perubahan berbasis teknologi, untuk menjadikan kampung yang terdepan dalam setiap aspek kegiatan.'
        />
      </Helmet>
      {/* <Header data={header} /> */}
      <section className='container-kontak w-full'>
        <div className='content-kontak'>
          <div className='box-article-kontak'>
            <span className='title-left-first'>What's it all about?</span>
            <h1 className='title-kontak text-8xl'>Drop us</h1>
            <h1 className='title-kontak text-8xl'>A line!</h1>
            <p className='article-kontak'>
              Dengan hadirnya teknologi website, lingkungan kita menjadi lebih
              terbuka dan efisien. Warga dapat melihat setiap kegiatan dan
              mengakses laporan kemajuan secara transparan. Inovasi ini
              menguatkan keterlibatan masyarakat dan meningkatkan pemahaman
              bersama terhadap pembangunan desa.
            </p>
          </div>
        </div>

        <div className='content-kontak'>
          <div className='box-article-kontak'>
            <div className='divider-content'>
              <span className='text-xl'>Find Us</span>
              <h1 className='text-7xl  text-font'>Location</h1>
            </div>
            <div className='divider-content'>
              <h1>DKI Jakarta</h1>
              <p>Lubang Buaya</p>
              <p>13810</p>
            </div>
          </div>
        </div>

        <div className='content-kontak'>
          <div className='box-article-kontak'>
            <div className='divider-content'>
              <span className='text-xl'>Got A Q?</span>
              <h1 className='text-7xl text-font'>Contact Us</h1>
            </div>
            <div className='divider-content'>
              <h1>Email IT?</h1>
              <p>xxxx@gmail.com</p>
            </div>
          </div>
        </div>

        <div className='content-kontak'>
          <div className='box-article-kontak'>
            <div className='divider-content'>
              <span className='text-xl'>the doors are open</span>
              <h1 className='text-7xl text-font'>Consultation Time</h1>
            </div>
            <div className='divider-content'>
              <p>Senin - minggu</p>
              <p>08:00 - 22:00</p>
          
            </div>
          </div>
        </div>

        <div className='content-kontak'>
          <div className='box-article-kontak'>
            <div className='divider-content'>
              <span className='text-xl'>Be Our Friends</span>
              <h1 className='text-7xl text-font'>Social Media</h1>
            </div>
            <div className='divider-content'>
              <p>INSTAGRAM</p>
              <p>FACEBOOK</p>
              <p>TIKTOK</p>
            </div>
          </div>
        </div>
        {/* <div className='py-8 lg:py-16 px-4 mx-auto max-w-screen-md'>
          <h2 className='mb-4 text-4xl tracking-tight font-extrabold text-center'>
            Kontak Kami
          </h2>
          <p className='mb-8 lg:mb-16 text-center desc-kontak'>
            Kami berkomitmen untuk memberikan layanan terbaik, hubungi kami untuk pertanyaan lebih lanjut.
          </p>
          <form action='#' className='space-y-8'>
            <div>
              <label
                htmlFor='email'
                className='label-input block mb-2 font-medium text-gray-900'
              >
                Your email
              </label>
              <input
                type='email'
                id='email'
                className='shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light'
                placeholder='name@budiboy'
                required
              />
            </div>
            <div>
              <label
                htmlFor='subject'
                className='label-input block mb-2 font-medium text-gray-900 '
              >
                Subject
              </label>
              <input
                type='text'
                id='subject'
                className='block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light'
                placeholder='Let us know how we can help you'
                required
              />
            </div>
            <div className='sm:col-span-2'>
              <label
                htmlFor='message'
                className='label-input block mb-2 text-sm font-medium'
              >
                Your message
              </label>
              <textarea
                id='message'
                rows='6'
                className='block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500'
                placeholder='Leave a comment...'
              ></textarea>
            </div>
            <button
              type='submit'
              className='py-3 px-5 text-sm font-medium text-center text-white rounded-lg bg-primary-700 sm:w-fit hover:bg-primary-800 focus:ring-4 focus:outline-none  btn-kontak'
            >
              Kirim Pesan
            </button>
          </form>
        </div> */}
      </section>
      {/* <Activity /> */}
      <Divider />
      <div className='box-location-kontak'>
        <Location />
      </div>
      <Good />
    </>
  );
}

export default Kontak
